import type { PresetId } from "../lib/presets";
import { WORKLOAD_PRESETS } from "../lib/presets";
import type { Workload } from "../lib/types";
import type { UiKey } from "../i18n/ui";

const PRESET_ORDER: PresetId[] = [
  "poc",
  "mvp",
  "web_app",
  "mobile_backend",
  "internal_tool",
  "api_light",
  "chat_app",
  "rag_search",
  "high_traffic_ai",
];

type Props = {
  t: (key: UiKey) => string;
  onApply: (w: Workload) => void;
};

export function PresetChips({ t, onApply }: Props) {
  return (
    <div className="presets">
      <span className="label">{t("preset.title")}</span>
      <div className="chips">
        {PRESET_ORDER.map((id) => (
          <button
            key={id}
            type="button"
            className="chip"
            onClick={() => onApply({ ...WORKLOAD_PRESETS[id] })}
          >
            {t(`preset.${id}` as UiKey)}
          </button>
        ))}
      </div>
      <style>{`
        .presets {
          margin-bottom: 1rem;
        }
        .label {
          display: block;
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--muted);
          margin-bottom: 0.45rem;
        }
        .chips {
          display: flex;
          flex-wrap: wrap;
          gap: 0.4rem;
        }
        .chip {
          border: 1px solid var(--border);
          background: var(--surface2);
          color: var(--text);
          padding: 0.3rem 0.65rem;
          border-radius: 999px;
          cursor: pointer;
          font-size: 0.8rem;
          font-family: var(--font);
        }
        .chip:hover {
          border-color: var(--accent-dim);
          color: var(--accent);
        }
        @media (max-width: 640px) {
          .chip {
            min-height: 44px;
            padding: 0.45rem 0.9rem;
            font-size: 0.85rem;
          }
        }
      `}</style>
    </div>
  );
}
